import React, { useEffect, useState } from 'react'
import { AGENCY_MANAGER, AGENCYMANAGER, BOB_REVIEW_ADMIN, BOBADMIN, BOBREVIEWADMIN, EA, FOLLOW_UP_SPECIALIST, FOLLOW_UP_SPECIALIST_ADMIN, getNameInitials, REVIEW_ADMIN, REVIEW_SCHEDULER, REVIEWADMIN, REVIEWSCHEDULER, RFS, SUPER_ADMIN, SUPERADMIN, VONBOARDER, VONSCHEDULER } from '../../utils/Constants'
import { Avatar, Card, Col, Row, Radio, Button, Icon } from 'antd';
import { useBoundStore } from '../../store/useBoundStore';



const CommonHeader = ({ user, onRoleChange, isHidden }) => {
    const { setRSFSCardFilters } = useBoundStore();
    const roles = JSON.parse(localStorage.getItem('roles')) || [];
    // const [toggleBtnState, setToogleBtnState] = useState(user.user_type == SUPER_ADMIN ? REVIEWSCHEDULER : user.user_type);
    const toggleBtnStateRSFSFromZustand = useBoundStore(state => state.RSFSCardFilters.selectedToggle);
    const toggleAdminBtnStateRSFSFromZustand = useBoundStore(state => state.RSFSCardFilters.selectedAdminToggle);
    const [toggleBtnState, setToogleBtnState] = useState(toggleBtnStateRSFSFromZustand);
    const [toggleAdminSwitchRole, setAdminToggleSwitchRole] = useState(toggleAdminBtnStateRSFSFromZustand);

    useEffect(() => {
        setToogleBtnState(toggleBtnStateRSFSFromZustand);
        setAdminToggleSwitchRole(toggleAdminBtnStateRSFSFromZustand)
    }, [toggleBtnStateRSFSFromZustand, toggleAdminBtnStateRSFSFromZustand]);



    const handleRoleSwitchChange = (role) => {
        localStorage.removeItem("agGridColumnState");
        const isAdminToggle =
            role === REVIEWADMIN ||
            role === EA ||
            role === BOBADMIN ||
            role === BOBREVIEWADMIN;

        setRSFSCardFilters(
            isAdminToggle
                ? {
                    defaultToggleUserRole: role,
                    selectedAdminToggle: role,
                    selectedAdminToggleAPI: role,
                }
                : {
                    defaultToggleUserRole: role,
                    selectedToggle: role,
                    selectedToggleAPI: role,
                }
        );
        setToogleBtnState(role);
        setAdminToggleSwitchRole(role);
        onRoleChange(role);
    };

    function getUserTypeLabel(userType) {
        switch (userType) {
            case EA:
                return FOLLOW_UP_SPECIALIST_ADMIN;
            case BOBADMIN:
                return FOLLOW_UP_SPECIALIST_ADMIN;
            case VONBOARDER:
                return FOLLOW_UP_SPECIALIST;
            case REVIEWADMIN:
                return REVIEW_ADMIN;
            case REVIEWSCHEDULER:
                return REVIEW_SCHEDULER;
            case BOBREVIEWADMIN:
                return BOB_REVIEW_ADMIN;
            case VONSCHEDULER:
                return RFS;
            case AGENCY_MANAGER:
                return AGENCYMANAGER;
            case SUPER_ADMIN:
                return SUPERADMIN;
            default:
                return REVIEW_ADMIN;
        }
    }
    return (
        <div>
            <Card bordered={false}>
                <Row gutter={16} type="flex" justify="space-between" align="middle">
                    <Col style={{ marginTop: 20 }}>
                        <Col style={{ display: 'flex', alignItems: 'center' }}>
                            {user && user.dp_url && user.dp_url !== null ? (<Avatar
                                className='custom-avatar'
                                style={{ marginRight: 10 }}
                                size={60}
                                src={user.dp_url}
                            // src={user.dp_url || "https://api.dicebear.com/7.x/miniavs/svg?seed=1"}
                            />) : (
                                <span
                                    style={{
                                        marginRight: 10,
                                        color: "rgb(22, 72, 151)",
                                        fontWeight: "600",
                                        fontFamily: "Poppins",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: "60px",
                                        height: "60px",
                                        fontSize: "24px",
                                        borderRadius: "50%",
                                        background: "#F0F2F5",
                                        padding: "15px"
                                    }} >{getNameInitials(`${user.first_name} ${user.last_name}`)}</span>
                            )}
                            <div>
                                <h3 style={{ color: '#164897', marginBottom: 0, fontWeight: 600 }}>
                                    {user.first_name} {user.last_name}
                                </h3>
                                <small style={{ fontSize: 14, marginTop: 0 }}>
                                    {getUserTypeLabel(user.user_type)}
                                </small>
                            </div>
                        </Col>

                    </Col>
                    {/* {console.log("ddd", user.user_type)} */}
                    {

                        !isHidden && (user.user_type == EA ||
                            user.user_type == BOBADMIN ||
                            user.user_type == REVIEWADMIN ||
                            user.user_type == SUPER_ADMIN ||
                            user.user_type == BOBREVIEWADMIN) && (<Col>

                                <Col>
                                    <small>Switch Role</small>
                                </Col>
                                <Col>
                                    <Radio.Group
                                        value={toggleAdminSwitchRole}
                                        onChange={(e) => handleRoleSwitchChange(e.target.value)}
                                    >
                                        <Radio.Button
                                            value="REVIEWADMIN"
                                            className={toggleAdminSwitchRole === REVIEWADMIN ? "review-btn-active" : "review-btn-inactive"}
                                            style={{ width: 230, textAlign: 'center', borderRadius: '20px 0px 0px 20px' }}
                                        >
                                            Review Admin
                                        </Radio.Button>
                                        <Radio.Button
                                            value="EA"
                                            className={toggleAdminSwitchRole === EA ? "ea-btn-active" : "ea-btn-inactive"}
                                            style={{ width: 230, textAlign: 'center', borderRadius: '0px 20px 20px 0px' }}
                                        >Follow-Up Specialist Admin
                                        </Radio.Button>
                                    </Radio.Group>
                                </Col>
                            </Col>)
                    }

                    {
                        //(user.user_type == VONBOARDER || user.user_type == REVIEWSCHEDULER)
                        roles && roles.length > 0 &&
                        (roles.includes("Review") && !roles.includes("FollowUp") && !roles.includes("Prospect") ||
                            (roles.includes('FollowUp') || roles.includes('Prospect')) && !roles.includes("Review"))
                        && (<Col>
                            <Button
                                type="primary"
                                className="bg-169763"
                            >
                                <Icon type="check" />
                                My Stats
                            </Button>
                        </Col>)
                    }





                    {
                        user.user_type == AGENCY_MANAGER
                        && (<Col>
                            <Button
                                type="primary"
                                className="bg-169763"
                            >
                                <Icon type="check" />
                                Agency Stats
                            </Button>
                        </Col>)
                    }





                    {

                        !isHidden && roles && roles.length > 0 &&
                        (roles.includes("Review") &&
                            (roles.includes("FollowUp") || roles.includes("Prospect")))
                        //user.user_type == VONSCHEDULER
                        //  (user.user_type == VONBOARDER || user.user_type == REVIEWSCHEDULER) 
                        && (<Col>

                            <Col>
                                <small>Switch Role</small>
                            </Col>
                            <Col>
                                <Radio.Group value={toggleBtnState}
                                    onChange={(e) => handleRoleSwitchChange(e.target.value)}
                                >
                                    <Radio.Button
                                        value="REVIEWSCHEDULER"
                                        className={toggleBtnState == REVIEWSCHEDULER ? "ea-btn-active" : "ea-btn-inactive"}
                                        style={{ width: 220, textAlign: 'center', borderRadius: '20px 0px 0px 20px' }}
                                    >Review Scheduler
                                    </Radio.Button>
                                    <Radio.Button
                                        value="VONBOARDER"
                                        className={toggleBtnState == VONBOARDER ? "review-btn-active" : "review-btn-inactive"}
                                        style={{ width: 220, textAlign: 'center', borderRadius: '0px 20px 20px 0px' }}
                                    >Follow-Up Specialist</Radio.Button>
                                </Radio.Group>
                            </Col>
                        </Col>)
                    }


                </Row>
            </Card>
        </div>
    )
}

export default CommonHeader



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/CommonHeader.js